<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="600" persistent>
      <v-card>
        <v-card-title class="text-h5"> {{ medication }} </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="item.amount"
                label="Amount Recieved/Passed"
                placeholder="Amount Recieved/Passed"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="types"
                v-model="item.type"
                label="Comments"
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="onSave">Save </v-btn>
          <v-btn color="primary" text @click="close">Cancel </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    medication: {
      Type: String
    }
  },
  data() {
    return {
      dialog: false,
      item: {
        amount: 0,
        type: "",
      },
      types: ["Pass", "Count", "Count (New Cycle)"],
    };
  },
  methods: {
    onSave(){
      this.$emit('controlled-data', this.item);
      this.dialog = false
    },
    showDialog(){
      this.dialog = true
    },
    close(){
      this.dialog = false
      this.$emit('close', true);
    }
  },
};
</script>
